import { ContentState, convertToRaw } from 'draft-js';

export default (text) => {
    if (typeof text !== 'string') return text;

    const content = ContentState.createFromText(text);
    return convertToRaw(content);
};
